// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the configuration from
// packages/oraclejet-preact/UNSAFE_Icon/themedIcons.config.json
import { ComponentProps } from 'preact';
import { withDirectionIcon } from '../UNSAFE_Icon';
import { IcoChevronRight, IcoChevronLeft } from '../UNSAFE_Icons';
type Props = ComponentProps<typeof IcoChevronRight>;
const CollapseIcon = (props: Props) => {
  const Component = withDirectionIcon(IcoChevronRight, IcoChevronLeft);
  return <Component {...props} />;
};
export default CollapseIcon;
